var _button;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import { BrandfolderHexColors } from "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
import { errorAlert, defaultAlert, successAlert, warningAlert, errorAlertDark, defaultAlertDark, successAlertDark, warningAlertDark } from "./alert.js";
import { dangerButton, blackButton, primaryButton, secondaryButton, tertiaryButton, textSecondaryButton, textTertiaryButton, textWarningButton, warningButton, whiteButton } from "./button.js";
import { defaultCheckboxLight } from "./checkbox.js";
import { defaultDividerLight, primaryDividerLight, defaultDividerDark, primaryDividerDark } from "./divider.js";
import { defaultDropdownLight, defaultDropdownPrimary } from "./dropdown.js";
import { defaultFieldsetLight, defaultFieldsetDark } from "./fieldset.js";
import { fontFamilyBold, fontFamilyBook, fontFamilyMedium, fontSizeLarge, fontSizeMedium, fontSizeSmall, fontSizeXLarge, fontSizeXSmall, fontSizeXxSmall, fontSizeXxLarge, fontWeightBold, fontWeightBook, fontWeightMedium } from "./fonts.js";
import { defaultInputLight } from "./input.js";
import { defaultListLight, defaultListPrimary } from "./list.js";
import { defaultListboxLight, defaultListboxDark } from "./listbox.js";
import { blackLoader, grayLoader, primaryLightLoader, warningLoader, whiteLoader, defaultLightShimmerLoader, primaryDarkLoader } from "./loader.js";
import { defaultOptionLight, defaultOptionDark } from "./option.js";
import { outlineOffset, outlineWidth } from "./outlines.js";
import { defaultPopout, primaryPopout } from "./popout.js";
import { defaultRadioLight } from "./radio.js";
import { defaultSwitchLight } from "./switch.js";
import { defaultTableLight, defaultTableDark } from "./table.js";
import { dangerTooltip, defaultTooltip, primaryTooltip } from "./tooltip.js";
var baseTheme = {
  alert: {
    error: errorAlert,
    none: defaultAlert,
    success: successAlert,
    warning: warningAlert
  },
  button: (_button = {
    danger: dangerButton,
    default: blackButton,
    primary: primaryButton,
    secondary: secondaryButton,
    tertiary: tertiaryButton
  }, _defineProperty(_button, 'text-secondary', textSecondaryButton), _defineProperty(_button, 'text-tertiary', textTertiaryButton), _defineProperty(_button, 'text-warning', textWarningButton), _defineProperty(_button, "warning", warningButton), _defineProperty(_button, "white", whiteButton), _button),
  checkbox: {
    default: defaultCheckboxLight
  },
  divider: {
    default: defaultDividerLight,
    primary: primaryDividerLight
  },
  dropdown: {
    default: defaultDropdownLight,
    primary: defaultDropdownPrimary
  },
  fieldset: {
    default: defaultFieldsetLight
  },
  font: {
    families: {
      bold: fontFamilyBold,
      book: fontFamilyBook,
      medium: fontFamilyMedium
    },
    sizes: {
      large: fontSizeLarge,
      medium: fontSizeMedium,
      small: fontSizeSmall,
      xlarge: fontSizeXLarge,
      xsmall: fontSizeXSmall,
      xxsmall: fontSizeXxSmall,
      xxlarge: fontSizeXxLarge
    },
    weights: {
      bold: fontWeightBold,
      book: fontWeightBook,
      medium: fontWeightMedium
    }
  },
  input: {
    default: defaultInputLight
  },
  loader: {
    black: blackLoader,
    gray: grayLoader,
    primary: primaryLightLoader,
    warning: warningLoader,
    white: whiteLoader
  },
  link: {
    outlineColorFocus: '#4462C9',
    textColor: '#4462C9',
    textColorActive: '#364EA3',
    textColorDisabled: '#BCBCBC',
    textColorFocus: '#1D3163',
    textColorHover: '#1D3163',
    textColorVisited: '#4462C9'
  },
  list: {
    default: defaultListLight,
    primary: defaultListPrimary
  },
  listbox: {
    default: defaultListboxLight
  },
  option: {
    default: defaultOptionLight
  },
  outline: {
    offset: outlineOffset,
    style: 'solid',
    width: outlineWidth
  },
  popout: {
    default: defaultPopout,
    primary: primaryPopout
  },
  radio: {
    default: defaultRadioLight
  },
  shimmerLoader: {
    default: defaultLightShimmerLoader
  },
  switch: {
    default: defaultSwitchLight
  },
  table: {
    default: defaultTableLight
  },
  text: {
    default: BrandfolderHexColors.Text
  },
  tooltip: {
    danger: dangerTooltip,
    default: defaultTooltip,
    primary: primaryTooltip
  }
};
var darkTheme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  alert: _objectSpread(_objectSpread({}, baseTheme.alert), {}, {
    error: errorAlertDark,
    none: defaultAlertDark,
    success: successAlertDark,
    warning: warningAlertDark
  }),
  button: _objectSpread(_objectSpread({}, baseTheme.button), {}, {
    default: whiteButton
  }),
  darkMode: true,
  divider: _objectSpread(_objectSpread({}, baseTheme.divider), {}, {
    default: defaultDividerDark,
    primary: primaryDividerDark
  }),
  fieldset: _objectSpread(_objectSpread({}, baseTheme.fieldset), {}, {
    default: defaultFieldsetDark
  }),
  link: {
    outlineColorFocus: '#93a4e0',
    textColor: '#93a4e0',
    textColorActive: '#6c83d4',
    textColorDisabled: '#e2e7f7',
    textColorFocus: '#bbc6eb',
    textColorHover: '#bbc6eb',
    textColorVisited: '#93a4e0'
  },
  listbox: _objectSpread(_objectSpread({}, baseTheme.listbox), {}, {
    default: defaultListboxDark
  }),
  loader: _objectSpread(_objectSpread({}, baseTheme.loader), {}, {
    primary: primaryDarkLoader
  }),
  option: _objectSpread(_objectSpread({}, baseTheme.option), {}, {
    default: defaultOptionDark
  }),
  table: _objectSpread(_objectSpread({}, baseTheme.table), {}, {
    default: defaultTableDark
  }),
  text: _objectSpread(_objectSpread({}, baseTheme.text), {}, {
    default: BrandfolderHexColors.White
  })
});
var lightTheme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  darkMode: false
});
export { darkTheme, lightTheme };